const convertJs = require("./convert")
module.exports = {
  bNaN (num) {
    return parseFloat(num).toString() === "NaN" || isNaN(num)
  },
  /**
   * 合计数值
   * @param {Array<Float>} nums 
   */
  Sum (nums) {
    nums = nums || null
    if (nums == null) {
      return 0;
    }

    // 判断是否是数组
    if (!Array.isArray(nums)) {
      return 0;
    }

    const sumValue = convertJs.convertDecimal(nums.reduce((pre, curr) => pre + curr));
    return sumValue;
  },
  Add (...nums) {
    var total = 0;

    for (let num of nums) {
      if (!this.bNaN(num)) {
        total += parseFloat(num)

        total = convertJs.convertDecimal(total)
      }
    }
    return total;
  },
  Subtraction (...nums) {
    var total = 0;

    var i = -1;
    for (let num of nums) {
      i++;
      if (this.bNaN(num)) {
        total = NaN
        break;
      }

      if (i == 0) {
        total = num
        continue;
      }

      total -= parseFloat(num)

      total = convertJs.convertDecimal(total)
    }
    return total;
  }
}
